import { render, staticRenderFns } from "./ReceiptsFilters.vue?vue&type=template&id=51987866&"
import script from "./ReceiptsFilters.vue?vue&type=script&lang=js&"
export * from "./ReceiptsFilters.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51987866')) {
      api.createRecord('51987866', component.options)
    } else {
      api.reload('51987866', component.options)
    }
    module.hot.accept("./ReceiptsFilters.vue?vue&type=template&id=51987866&", function () {
      api.rerender('51987866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/components/ReceiptsFilters.vue"
export default component.exports